module.exports = "/_next/static/images/penfold-banner-md-b4f483866ef06016697cc05d0770372d.png";